import { render, staticRenderFns } from "./pet.vue?vue&type=template&id=0b13d7c7&"
import script from "./pet.vue?vue&type=script&lang=js&"
export * from "./pet.vue?vue&type=script&lang=js&"
import style0 from "./pet.vue?vue&type=style&index=0&id=0b13d7c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports